import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { AuthShell, GoogleBtn } from "@/pages/Login";

export default function Register() {
    const { register, startGoogleLogin } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
    const [loading, setLoading] = useState(false);
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await register(form);
            toast.success("Account created!");
            navigate("/account");
        } catch (err) {
            toast.error(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell title="Create Account">
            <form onSubmit={submit} className="space-y-4">
                <input data-testid="register-name" required placeholder="Full Name" value={form.name} onChange={set("name")} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <input data-testid="register-email" type="email" required placeholder="Email" value={form.email} onChange={set("email")} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <input data-testid="register-phone" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <input data-testid="register-password" type="password" required placeholder="Password (min 6 characters)" value={form.password} onChange={set("password")} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <button data-testid="register-submit" disabled={loading} className="w-full bg-ink text-cream py-3 text-sm uppercase tracking-[0.15em] hover:bg-gold transition-colors disabled:opacity-50">{loading ? "Creating…" : "Create Account"}</button>
            </form>
            <div className="flex items-center gap-3 my-5 text-xs text-muted-foreground"><span className="flex-1 h-px bg-[#E8DFD5]" />OR<span className="flex-1 h-px bg-[#E8DFD5]" /></div>
            <GoogleBtn onClick={startGoogleLogin} />
            <p className="text-center text-sm text-muted-foreground mt-6">Already have an account? <Link to="/login" className="text-gold hover:underline">Sign in</Link></p>
        </AuthShell>
    );
}
